module.exports = __webpack_public_path__ + "./images/tier5.jpg";